import React, { memo, useState } from 'react'
import styles from './teammember.module.scss'
import { useNavigate } from 'react-router-dom'
import { SolarProduct } from '../../../../../model/solar-product/solar-product'
import { ApplicationRoutes } from '../../../../../routes'
import DeleteTeamMemberDialog from './DeleteTeamMemberDialog'
import { UtilityTeamMember } from '../../../../../model/utility-users/utility-team-member'
import { DeleteIcon, PenIcon } from '../../../../../assets/icons'
import TeamMemberSideDialog from './TeamMemberSideDialog'
import { hasPermission } from '../../../../../guards/common/authentification-functions'
import { UtilityPermissions } from '../../../../../model/permissions/permissions'

type Props = {
    user: UtilityTeamMember
    onClose: () => void
    triggerLoad? : () => void
}

const TeamMemberOptionsDialog: React.FC<Props> = memo((props: Props) => {
    const { onClose, user, triggerLoad } = props

    const [deleteTeamMemberOpen, setDeleteTeamMemberOpen] = useState(false)
    const [editTeamMemberOpen, setEditTeamMemberOpen] = useState(false)

    const navigate = useNavigate()

    const handleEditTeamMember = (e: any) => {
        e.stopPropagation();
        setEditTeamMemberOpen(true);
    }

    const openDeleteTeamMember = (e: any) => {
        e.stopPropagation();
        setDeleteTeamMemberOpen(true);
    }

    const closeDeleteTeamMember = () => {
        setDeleteTeamMemberOpen(false)
        onClose()
    }

    const handleTeamMemberDelete = () => {
        closeDeleteTeamMember()
    }

    return (
        <>
            <div className={styles.dialogBackdrop} onClick={onClose}/>
            <div className={styles.dialogContainer}>
                {hasPermission(UtilityPermissions.EditUtilityUser) && <button className={`standardButton ${styles.button}`} onClick={handleEditTeamMember}>
                    <PenIcon />
                    Edit 
                </button>}
                {hasPermission(UtilityPermissions.DeleteUtilityUser) && <button className={`standardButton ${styles.button} ${styles.deleteButton} `} onClick={openDeleteTeamMember}>
                    <DeleteIcon />
                    Delete
                </button>}
            </div>            
            {
            deleteTeamMemberOpen && <DeleteTeamMemberDialog onCloseDialog={closeDeleteTeamMember} onTeamMemberDelete={handleTeamMemberDelete} user={user} />
            }         
            {
            editTeamMemberOpen && <TeamMemberSideDialog isEdit={true} onCloseDialog={closeDeleteTeamMember} onDone={onClose} user={user} />
            }
        </>

    )
})

export default TeamMemberOptionsDialog